"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("../styles");
var strings_json_1 = __importDefault(require("../../../globals/strings.json"));
require("../../../assets/style.css");
var UploadError = function (_a) {
    var file = _a.file, onDelete = _a.onDelete, errors = _a.errors, largeFile = _a.largeFile, fileTypeNotAllowed = _a.fileTypeNotAllowed, defaultError = _a.defaultError;
    var classes = (0, styles_1.useStyles)();
    var getErrorType = function (error) {
        switch (error.code) {
            case 'file-too-large':
                return largeFile ? largeFile.replace('$1', (file.size).toString()) : strings_json_1.default.strings.uploader.Large_File.replace('$1', (file.size).toString());
            case 'file-invalid-type':
                return fileTypeNotAllowed ? fileTypeNotAllowed.replace('$1', file.type) : strings_json_1.default.strings.uploader.File_Type_Not_Allowed.replace('$1', file.type);
            default:
                return defaultError ? defaultError : strings_json_1.default.strings.uploader.Error;
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(core_1.Typography, { className: classes.uploadErrorTypography }, file.name)),
        react_1.default.createElement(core_1.Grid, { container: true, direction: "column", className: classes.uploadErrorGrid },
            react_1.default.createElement(core_1.Grid, null,
                react_1.default.createElement(core_1.IconButton, { onClick: function () { return onDelete(); } },
                    react_1.default.createElement("i", { className: "ppi ppi-trash", id: "trashUploaderIcon" }))),
            errors
                // .filter((error) => error.code.startsWith("pr-"))
                .map(function (error) { return (react_1.default.createElement(core_1.Grid, { item: true, className: classes.uploadErrorItem, key: error.code },
                react_1.default.createElement(core_1.Typography, { color: "error", className: classes.fontFamily }, getErrorType(error)))); }))));
};
exports.default = UploadError;
